module.exports = __webpack_public_path__ + "static/media/PDF.9cc32cca.svg";